import script from "./liveDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./liveDetail.vue?vue&type=script&setup=true&lang=js"

import "./liveDetail.vue?vue&type=style&index=0&id=e487b2c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e487b2c4"]])

export default __exports__